export default __webpack_public_path__ + "9dae2991f4fb30a5f7e0d60ef4bc7568.ttf";